import View from "@pathwright/ui/src/components/ui/View"
import { useToggleIntercomVisibility } from "@pathwright/web/src/modules/intercom/IntercomProvider"
import "./Message.css"
import MessageForm from "./MessageFormContainer"
import MessageSuccess from "./MessageSuccess"

const Message = (props) => {
  // The Intercom launcher can hide the "Send" button in certain cases.
  useToggleIntercomVisibility()

  return (
    <View.Primary className="Message">
      {props.send_success ? (
        <MessageSuccess onClose={props.onClose} />
      ) : (
        <MessageForm />
      )}
    </View.Primary>
  )
}

Message.displayName = "Message"

export default Message
